<style lang="scss" src='./ProductsCarousel.scss' scoped></style>
<template src="./ProductsCarousel.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";
  import Product from '@/components/product/Product'
  export default {
    name: 'ProductsCarousel',
    props: {
      title: '',
      products: [],
      category_id: null,
    },
    components: {
      Product
    },
    data() {
      return {
        showLeftBtn: false,
        showRightBtn: true,
        element: null,
        crouselId: null,
      };
    },
    computed: {},

    methods: {
      fnRightSrcoll() {
        let scrollAmount = 0;
        var slideTimer = setInterval(  () => {
          this.element.scrollLeft += 5;
          scrollAmount += 5;
          if (scrollAmount >= 400) {
            window.clearInterval(slideTimer);
          }
        }, 5);
      },
      fnLeftSrcoll() {
        let scrollAmount = 0;
        var slideTimer = setInterval(  () => {
          this.element.scrollLeft -= 5;
          scrollAmount += 5;
          if (scrollAmount >= 400) {
            window.clearInterval(slideTimer);
          }
        }, 5);
      },
      fnCarouselScroll(event){
        if (event.target.scrollLeft > 20) {
          this.showLeftBtn = true;
        } else {
          this.showLeftBtn = false;
        }
        if ((event.target.scrollLeft + event.target.offsetWidth )< event.target.scrollWidth) {
          this.showRightBtn = true;
        } else {
          this.showRightBtn = false;
        }
      }
    },
    beforeCreate() {},
    created() {
      this.crouselId = Math.random().toString(36).substr(2);
    },
    mounted() {
      this.element = document.getElementById(this.crouselId);
      this.element.addEventListener('scroll',this.fnCarouselScroll);
    },
    beforeDestroy() {
      this.element.removeEventListener('scroll',this.fnCarouselScroll);
    },
  };

</script>
